import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { EmbeddedReportService } from './embedded-report.service';
import { Subscription } from 'rxjs';
import { AlertService } from '../../alert/alert.service';

@Component({
    selector: 'embedded-report',
    templateUrl: './embedded-report.component.html',
    styleUrls: ['./embedded-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmbeddedReportComponent {
  public urlSub: Subscription;
  public url: SafeResourceUrl | null = null;
  constructor(
    public embeddedReportService: EmbeddedReportService,
    public alertService: AlertService
  ) {}

  ngOnInit() {
    this.urlSub = this.embeddedReportService.url$.subscribe(
      (url) => (this.url = url)
    );
  }
  ngOnDestroy() {
    this.urlSub?.unsubscribe();
  }
}
